import { SecurityAccessFeaturesEnum } from 'bff/client';

export function canAccessAll(
  features: SecurityAccessFeaturesEnum | SecurityAccessFeaturesEnum[],
  userFeatures: SecurityAccessFeaturesEnum[]
): boolean {
  const checkFeatures = Array.isArray(features) ? features : [features];
  return checkFeatures.every((feature) => userFeatures.includes(feature));
}

export function canAccessAny(
  features: SecurityAccessFeaturesEnum | SecurityAccessFeaturesEnum[],
  userFeatures: SecurityAccessFeaturesEnum[]
): boolean {
  const checkFeatures = Array.isArray(features) ? features : [features];
  return checkFeatures.some((feature) => userFeatures.includes(feature));
}
